import waterDistributionChangesLegend from "../../assets/images/legend/水体变化数据.png";
import waterFrequency1yearLegend from "../../assets/images/legend/水体频率一年.png";
import waterFrequency2yearLegend from "../../assets/images/legend/水体频率二年.png";
import waterFrequency3yearLegend from "../../assets/images/legend/水体频率三年.png";
import waterClarityChangeLegend from "../../assets/images/legend/水体透明度变化-图例.png";
import waterGoodLegend from "../../assets/images/legend/水质良好.png";
import WaterDistributionChange from "../../assets/images/examples/WaterDistributionChange.png";
import WaterCoverageFrequency from "../../assets/images/examples/WaterCoverageFrequency.png";
import WaterClarityChange from "../../assets/images/examples/WaterClarityChange.png";
import WaterGoodQualityArea from "../../assets/images/examples/WaterGoodQualityArea.png";
import fvcChange from "../../assets/images/examples/FVCChange.png";
import forestGrass from "../../assets/images/examples/ForestGrassClassChange.png";
import forestGrassChangeLegend from "../../assets/images/legend/林草类型变化.png";
import fvcChangeLegend from "../../assets/images/legend/植被覆盖度变化.png";
import generateMosaicUrl from "../../utils/generateMosaicUrl";

const analysisCollections = {
  collections: [
    {
      id: "water_distribution_changes_analysis",
      title: "Surface Water Distribution Change Analysis",
      extent: {
        temporal: {
          interval: [
            ["2000-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
            ["2000-01-01T00:00:00Z", "2000-12-31T23:59:59.999999Z"],
            ["2010-01-01T00:00:00Z", "2010-12-31T23:59:59.999999Z"],
            ["2020-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
          ],
        },
      },
      summaries: {
        info: {
          year: "2000, 2010, 2020",
          region: "Hindu Kush Himalaya",
          category: "water",
        },
        source: "aircas_water_distribution_yearly",
        source_title: "Water body distribution of HKH region for 2000, 2010, 2020",
        map_title: "Surface Water Distribution Change",
        thumbnail: WaterDistributionChange,
        chart_title: "Surface Water Area Change",
        select_year_num: 2,
        collection_tile_url: [
          {
            url: generateMosaicUrl("water_distribution_change", ["2000", "2010"]),
            year: ["2000", "2010"],
            legend: waterDistributionChangesLegend,
          },
          {
            url: generateMosaicUrl("water_distribution_change", ["2010", "2020"]),
            year: ["2010", "2020"],
            legend: waterDistributionChangesLegend,
          },
          {
            url: generateMosaicUrl("water_distribution_change", ["2000", "2020"]),
            year: ["2000", "2020"],
            legend: waterDistributionChangesLegend,
          },
        ],
      },
      description:
        "This analysis shows a map of surface water distribution change from one time to another time. The change is represented by ‘increase’, ‘decrease’ and  ‘no change’.",
    },
    {
      id: "water_distribution_frequency_analysis",
      title: "Surface Water Coverage Frequency Analysis",
      extent: {
        temporal: {
          interval: [
            ["2000-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
            ["2000-01-01T00:00:00Z", "2000-12-31T23:59:59.999999Z"],
            ["2010-01-01T00:00:00Z", "2010-12-31T23:59:59.999999Z"],
            ["2020-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
          ],
        },
      },
      summaries: {
        chart_title: "Surface Water Coverage Change",
        source: "aircas_water_distribution_yearly",
        source_title: "Water body distribution of HKH region for 2000, 2010, 2020",
        map_title: "Surface Water Coverage Frequency",
        info: {
          year: "2000, 2010, 2020",
          region: "Hindu Kush Himalaya",
          category: "water",
        },
        thumbnail: WaterCoverageFrequency,
        collection_tile_url: [
          {
            legend: waterFrequency1yearLegend,
            url: generateMosaicUrl("aircas_water_distribution_yearly", "2000"),
            year: ["2000"],
          },
          {
            legend: waterFrequency1yearLegend,
            url: generateMosaicUrl("aircas_water_distribution_yearly", "2010"),
            year: ["2010"],
          },
          {
            legend: waterFrequency1yearLegend,
            url: generateMosaicUrl("aircas_water_distribution_yearly", "2020"),
            year: ["2020"],
          },
          {
            legend: waterFrequency2yearLegend,
            url: generateMosaicUrl("water_distribution_statistics", ["2000", "2010"]),
            year: ["2000", "2010"],
          },
          {
            legend: waterFrequency2yearLegend,
            url: generateMosaicUrl("water_distribution_statistics", ["2010", "2020"]),
            year: ["2010", "2020"],
          },
          {
            legend: waterFrequency2yearLegend,
            url: generateMosaicUrl("water_distribution_statistics", ["2000", "2020"]),
            year: ["2000", "2020"],
          },
          {
            legend: waterFrequency3yearLegend,
            url: generateMosaicUrl("water_distribution_statistics", ["2000", "2010", "2020"]),
            year: ["2000", "2010", "2020"],
          },
        ],
      },
      description:
        "This analysis shows a map of surface water coverage frequency from one time to another time. The coverage frequency is represented by ‘0’, ‘1’ , ‘2’ and  ‘3’.",
    },
    {
      id: "water_good_quality_analysis",
      title: "Change in Proportion of Water Bodies with Good Water Quality",
      extent: {
        temporal: {
          interval: [
            ["2000-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
            ["2000-01-01T00:00:00Z", "2000-12-31T23:59:59.999999Z"],
            ["2010-01-01T00:00:00Z", "2010-12-31T23:59:59.999999Z"],
            ["2020-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
          ],
        },
      },
      summaries: {
        chart_title: "Change in Proportion of Water Bodies with Good Water Quality",
        select_year_num: 0,
        map_title: "Good Water Quality Change",
        source: "aircas_water_clarity_yearly",
        source_title: "Water clarity of HKH region for 2000, 2010, 2020",
        info: {
          year: "2000, 2010, 2020",
          region: "Hindu Kush Himalaya",
          category: "water",
        },
        thumbnail: WaterGoodQualityArea,
        collection_tile_url: [
          {
            url: generateMosaicUrl("water_clarity_statistics", "2000"),
            year: ["2000"],
            legend: waterGoodLegend,
          },
          {
            url: generateMosaicUrl("water_clarity_statistics", "2010"),
            year: ["2010"],
            legend: waterGoodLegend,
          },
          {
            url: generateMosaicUrl("water_clarity_statistics", "2020"),
            year: ["2020"],
            legend: waterGoodLegend,
          },
        ],
      },
      description:
        "The spatio-temporal analysis of good water body quality is the analysis of the distribution of the pixels with water body clarity greater than 0.5 in different years. ",
    },
    {
      id: "water_body_clarity_changes_analysis",
      title: "Water Body Clarity Change Analysis",
      extent: {
        temporal: {
          interval: [
            ["2000-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
            ["2000-01-01T00:00:00Z", "2000-12-31T23:59:59.999999Z"],
            ["2010-01-01T00:00:00Z", "2010-12-31T23:59:59.999999Z"],
            ["2020-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
          ],
        },
      },
      summaries: {
        chart_title: "Proportion of Water Body Clarity Change",
        map_title: "Water Body Clarity Change ",
        select_year_num: 2,
        source: "aircas_water_clarity_yearly",
        source_title: "Water body clarity of HKH region for 2000, 2010, 2020",
        info: {
          year: "2000, 2010, 2020",
          region: "Hindu Kush Himalaya",
          category: "water",
        },
        thumbnail: WaterClarityChange,
        collection_tile_url: [
          {
            legend: waterClarityChangeLegend,
            url: generateMosaicUrl("water_clarity_change", ["2000", "2010"]),
            year: ["2000", "2010"],
          },
          {
            legend: waterClarityChangeLegend,
            url: generateMosaicUrl("water_clarity_change", ["2010", "2020"]),
            year: ["2010", "2020"],
          },
          {
            legend: waterClarityChangeLegend,
            url: generateMosaicUrl("water_clarity_change", ["2000", "2020"]),
            year: ["2000", "2020"],
          },
        ],
      },
      description:
        "This analysis shows a map of  water body clarity change from one time to another time. The change is represented by the D-value between two times, including three changes: 'increase', 'decrease' and 'unchange'. ",
    },
    {
      id: "fvc_change",
      title: "Fractional Vegetation Cover Change Analysis",
      extent: {
        temporal: {
          interval: [
            ["2000-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
            ["2000-01-01T00:00:00Z", "2000-12-31T23:59:59.999999Z"],
            ["2010-01-01T00:00:00Z", "2010-12-31T23:59:59.999999Z"],
            ["2020-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
          ],
        },
      },
      summaries: {
        chart_title: "FVC Change",
        map_title: "FVC Change",
        select_year_num: 2,
        source: "aircas_FVC_yearly",
        source_title:
          "Fractional Vegetation Cover (FVC) dataset in the HKH for the year  2000, 2010, 2020 (30m)",
        info: {
          year: "2000, 2010, 2020",
          region: "Hindu Kush Himalaya",
          category: "ecology",
        },
        thumbnail: fvcChange,
        collection_tile_url: [
          {
            legend: fvcChangeLegend,
            url: generateMosaicUrl("fvc_change", ["2000", "2010"]),
            year: ["2000", "2010"],
          },
          {
            legend: fvcChangeLegend,
            url: generateMosaicUrl("fvc_change", ["2010", "2020"]),
            year: ["2010", "2020"],
          },
          {
            legend: fvcChangeLegend,
            url: generateMosaicUrl("fvc_change", ["2000", "2020"]),
            year: ["2000", "2020"],
          },
        ],
      },
      description:
        "This analysis shows a map of fractional vegetation cover change from one time to another time. The change is represented by the value between two times, including three changes: ‘increase’, ‘decrease’ and ‘no change’.",
    },
    {
      id: "forest_grass_change",
      title: "Transitions in Forest and Grass Classes",
      extent: {
        temporal: {
          interval: [
            ["2000-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
            ["2000-01-01T00:00:00Z", "2000-12-31T23:59:59.999999Z"],
            ["2010-01-01T00:00:00Z", "2010-12-31T23:59:59.999999Z"],
            ["2020-01-01T00:00:00Z", "2020-12-31T23:59:59.999999Z"],
          ],
        },
      },
      summaries: {
        chart_title: "Forest and Grass Classes Change",
        map_title: "Forest and Grass Classes Change",
        select_year_num: 2,
        source: "aircas_forest_and_grass_distribution_yearly",
        source_title:
          "Fractional Vegetation Cover (FVC) dataset in the HKH for the year  2000, 2010, 2020 (30m)",
        info: {
          year: "2000, 2010, 2020",
          region: "Hindu Kush Himalaya",
          category: "ecology",
        },
        thumbnail: forestGrass,
        collection_tile_url: [
          {
            legend: forestGrassChangeLegend,
            url: generateMosaicUrl("forest_grass_change", ["2000", "2010"]),
            year: ["2000", "2010"],
          },
          {
            legend: forestGrassChangeLegend,
            url: generateMosaicUrl("forest_grass_change", ["2010", "2020"]),
            year: ["2010", "2020"],
          },
          {
            legend: forestGrassChangeLegend,
            url: generateMosaicUrl("forest_grass_change", ["2000", "2020"]),
            year: ["2000", "2020"],
          },
        ],
      },
      description:
        "This analysis shows a map of transitions in forest and grass classes from one time to another time, including nine changes: ‘forest’, ‘forest to grass’, ‘forest to others’, ‘grass’, ‘grass to forest’, ‘grass to others’, ‘others’, ‘others to forest’ and ‘others to grass’.",
    },
  ],
};

export default analysisCollections;
